import React from "react";
import { Button, DotsVertical, Edit01, Menu, Trash01 } from "@opendate-app/setlist";
import { FansCount, ViewLink } from "./SegmentRow";

const linkStyle = { color: "var(--sl-text-primary)", fontWeight: 600, textDecoration: "none" };

export const customSegmentColumns = (teamId, onEdit, onDelete) => [
  {
    key: "name",
    header: "Name",
    primary: true,
    render: (segment) => <a href={`/teams/${teamId}/segments/${segment.id}`} style={linkStyle}>{segment.name}</a>,
  },
  { key: "created_at", header: "Created", render: (segment) => <span style={{ color: "var(--sl-text-tertiary)", whiteSpace: "nowrap" }}>{segment.created_at}</span> },
  { key: "fans_count", header: "Fans", align: "right", width: "120px", render: (segment) => <FansCount count={segment.fans_count} /> },
  {
    key: "view",
    header: "",
    align: "right",
    width: "80px",
    render: (segment) => <ViewLink href={`/teams/${teamId}/segments/${segment.id}`} label={`View ${segment.name}`} />,
  },
  {
    key: "actions",
    header: "",
    width: "48px",
    render: (segment) => (
      <Menu
        placement="bottom-end"
        minWidth={160}
        trigger={<Button variant="tertiary" size="sm" icon={DotsVertical} aria-label="Segment actions" />}
        items={[
          { label: "Edit", icon: Edit01, onClick: () => onEdit(segment) },
          { label: "Delete", icon: Trash01, destructive: true, onClick: () => onDelete(segment) },
        ]}
      />
    ),
  },
];
